/**
 * Application configuration — single source of truth for identity and env.
 * This project is fully independent: its own app id, storage keys and database.
 */

export const APP_CONFIG = {
  /** Unique application identifier — must not collide with any other project. */
  appId: 'com.shinua99.tasks',
  appName: 'משימות שינוע 99',
  appDescription: 'מערכת לניהול משימות, רכבים וצוותים',
  version: '0.4.0',

  locale: 'he-IL',
  direction: 'rtl' as const,
  timeZone: 'Asia/Jerusalem',

  /** Prefix for every localStorage / sessionStorage key this app writes. */
  storagePrefix: 'shinua99:',

  /**
   * Remote API base — empty means offline-only (local IndexedDB).
   * Optional-chained so the module also loads outside the Vite bundle, where
   * `import.meta.env` does not exist (the healthcheck imports it directly).
   */
  apiBaseUrl: import.meta.env?.VITE_API_BASE_URL ?? '',
} as const;

export const storageKey = (name: string): string => `${APP_CONFIG.storagePrefix}${name}`;
